/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_CustomInputs */

const en_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const de_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const es_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const fr_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_custom = en_admin_external_booking_edit_order_summary_custom;

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_CustomInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_custom = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_CustomInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_CustomInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_custom(inputs)
	return ro_admin_external_booking_edit_order_summary_custom(inputs)
});
export { admin_external_booking_edit_order_summary_custom as "admin.external_booking_edit.order_summary.custom" }